function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { PDF_PAGE_ROW_FONT_SIZE, PDF_PAGE_ROW_LINE_HEIGHT, PDF_PAGE_ROW_PADDING_Y } from '../../constants/applicationForm/common';
export var toPdfSafeText = function toPdfSafeText(value) {
  if (!value) return ''; // pdf-lib standard fonts (Helvetica) use WinAnsiEncoding, so only WinAnsi-encodable characters can be
  // drawn without throwing. Keep printable ASCII, newlines, the Latin-1 supplement (\xA0-\xFF: currency
  // signs, middle dot and Western-European accents) and the Windows-1252 specials (euro, smart quotes,
  // dashes, trademark, ...); replace everything else (e.g. Polish/Czech/Hungarian letters, Greek,
  // Cyrillic, CJK) with a space so the standard font never fails to encode a glyph.

  return value.replace(/[^\x20-\x7E\xA0-\xFF\n\u20AC\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\u017D\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\u017E\u0178]/g, ' ');
};
export var wrapTextToLines = function wrapTextToLines(text, maxWidth, fontSize, pdfFont) {
  var lines = [];

  var _iterator = _createForOfIteratorHelper(text.split('\n')),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rawLine = _step.value;
      var line = '';

      var _iterator2 = _createForOfIteratorHelper(rawLine),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _char = _step2.value;
          var nextLine = line + _char;

          if (line && pdfFont.widthOfTextAtSize(nextLine, fontSize) > maxWidth) {
            lines.push(line);
            line = _char;
          } else {
            line = nextLine;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      lines.push(line);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return lines;
};
export var getTextEstimatedLineCount = function getTextEstimatedLineCount(value, config) {
  var widthPt = config.widthPt,
      _config$fontSize = config.fontSize,
      fontSize = _config$fontSize === void 0 ? 10 : _config$fontSize;
  if (!value) return 1;
  var safeWidth = Math.max(40, widthPt);
  var charsPerLine = Math.max(8, Math.floor(safeWidth / (fontSize * 0.52)));
  var chunks = value.split('\n');
  return chunks.reduce(function (count, chunk) {
    return count + Math.max(1, Math.ceil(chunk.length / charsPerLine));
  }, 0);
};
/**
 * Estimate how many lines a rich label block (titleLines) will occupy.
 * A small spacer line is counted whenever the line kind changes so each
 * declaration field (title / subTitle / descTitle / spec) stands on its own.
 */

export var getApplicationFormTextLineCount = function getApplicationFormTextLineCount() {
  var titleLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var widthPt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 120;

  if (!titleLines.length) {
    return 0;
  }

  var count = 0;
  var previousKind;
  titleLines.forEach(function (line) {
    if (previousKind && line.kind && line.kind !== previousKind) {
      count += 1;
    }

    previousKind = line.kind || previousKind;

    if (line.gapBefore && line.gapBefore > 0) {
      count += Math.ceil(line.gapBefore / PDF_PAGE_ROW_LINE_HEIGHT);
    }

    count += getTextEstimatedLineCount(toPdfSafeText(line.text), {
      widthPt: widthPt,
      fontSize: line.fontSize || PDF_PAGE_ROW_FONT_SIZE
    });
  });
  return count;
};
export var getPDFEstimateEditableRowHeight = function getPDFEstimateEditableRowHeight(row) {
  var _ref = row || {},
      title = _ref.title,
      content = _ref.content,
      titleLines = _ref.titleLines,
      minLines = _ref.minLines,
      leftTitleWidth = _ref.leftTitleWidth,
      rowWidth = _ref.rowWidth;

  var valueText = content || '';
  var safeLabelText = toPdfSafeText(title);
  var valueWidth = rowWidth - leftTitleWidth - 1;
  var labelLineCount = titleLines !== null && titleLines !== void 0 && titleLines.length ? getApplicationFormTextLineCount(titleLines, leftTitleWidth - 12) : getTextEstimatedLineCount(safeLabelText, {
    widthPt: leftTitleWidth - 12,
    fontSize: PDF_PAGE_ROW_FONT_SIZE
  });
  var valueLineCount = getTextEstimatedLineCount(valueText, {
    widthPt: valueWidth - 12,
    fontSize: PDF_PAGE_ROW_FONT_SIZE
  });
  var lineCount = Math.max(labelLineCount, valueLineCount, minLines || 0);
  return Math.max(PDF_PAGE_ROW_LINE_HEIGHT * 2, lineCount * PDF_PAGE_ROW_LINE_HEIGHT + PDF_PAGE_ROW_PADDING_Y * 2);
};